// extracted by mini-css-extract-plugin
export default {"content":"style_content__-iwtn","checkbox":"style_checkbox__Bzkmc"};